import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { DatasetValidationPage } from './DatasetValidationPage.jsx';

function DatasetValidationDialog({ onClose }) {
  const dialog = useRef(null);
  useEffect(() => {
    const element = dialog.current;
    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    element.showModal();
    document.body.style.overflow = 'hidden';
    return () => {
      element.close();
      document.body.style.overflow = previousOverflow;
      previousFocus?.focus();
    };
  }, []);
  function keepFocusInside(event) {
    if (event.key !== 'Tab') return;
    const controls = [...dialog.current.querySelectorAll('button:not(:disabled), input:not(:disabled), a[href], [tabindex="0"]')];
    const first = controls[0], last = controls.at(-1);
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  }
  return createPortal(<dialog ref={dialog} className="dataset-validation-dialog" aria-labelledby="validation-title" onKeyDown={keepFocusInside} onCancel={event => { event.preventDefault(); onClose(); }}>
    <div className="dataset-validation-dialog-toolbar"><button type="button" autoFocus onClick={onClose} aria-label="Close dataset validation">CLOSE ×</button></div>
    <DatasetValidationPage embedded />
  </dialog>, document.body);
}

export function DatasetValidationButton() {
  const [open, setOpen] = useState(false);
  return <><button type="button" className="dataset-validation-button" aria-haspopup="dialog" onClick={() => setOpen(true)}>VALIDATE DATASET ZIP</button>
    {open && <DatasetValidationDialog onClose={() => setOpen(false)} />}
  </>;
}
